import { createMultiStyleConfigHelpers as r } from "@chakra-ui/react";
import { ThemeColorToken as o, ThemeBorderToken as n, ThemeFontSizeToken as t, ThemeFontToken as c } from "../theme-tokens.js";
import { radioAnatomy as i } from "../../../packages/casper-ui-library/node_modules/@chakra-ui/anatomy/dist/esm/components.js";
const { defineMultiStyleConfig: l } = r(i.keys), e = {
  content: '""',
  display: "inline-block",
  pos: "relative",
  w: "50%",
  h: "50%",
  borderRadius: "50%",
  bg: o.OnAccent
}, d = {
  label: {
    color: o.OnSurface,
    fontFamily: c.Body,
    fontSize: t.Medium,
    _disabled: {
      opacity: 1
    }
  },
  control: {
    border: n.Small,
    borderColor: o.OnBackground,
    color: o.OnAccent,
    bg: "transparent",
    width: "24px",
    height: "24px",
    minH: "24px",
    minW: "24px",
    _disabled: {
      opacity: 0.48,
      color: o.OnAccent,
      borderColor: o.OnBackground,
      bg: "transparent"
    },
    _checked: {
      bg: o.Accent,
      borderColor: o.Accent,
      _before: {
        ...e
      },
      _disabled: {
        bg: o.Accent,
        borderColor: o.Accent,
        _before: {
          ...e
        }
      }
    }
  }
}, p = l({
  baseStyle: d
});
export {
  p as radioConfig
};
